import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const DocumentIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="48" height="67" viewBox="0 0 48 67" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.4873 1.17529C34.1688 1.17541 34.8249 1.43496 35.3223 1.90088L46.3896 12.2671C46.9316 12.7747 47.2393 13.4846 47.2393 14.2271V62.8599C47.2393 64.3426 46.0373 65.5443 44.5547 65.5444H4C2.51724 65.5444 1.31543 64.3426 1.31543 62.8599V3.85986C1.31543 2.3771 2.51724 1.17529 4 1.17529H33.4873Z"
      fill="#F2F2F2"
      stroke="#454643"
      strokeWidth="1.36957"
    />
    <path
      d="M29.3721 55.3702C29.3721 55.3702 32.0732 56.4099 33.8112 56.1372C35.8887 55.8112 36.3014 53.2718 38.4036 53.3255C40.1167 53.3694 42.2864 55.3702 42.2864 55.3702"
      stroke="#121212"
      strokeWidth="2.58287"
      strokeLinecap="round"
    />
    <path d="M7.16602 16.9912H41.389" stroke="#121212" strokeWidth="2.58287" strokeLinecap="round" />
    <path d="M7.16602 23.8684H41.389" stroke="#121212" strokeWidth="2.58287" strokeLinecap="round" />
    <path d="M7.16602 30.7456H41.389" stroke="#121212" strokeWidth="2.58287" strokeLinecap="round" />
    <path d="M7.16602 37.6228H41.389" stroke="#121212" strokeWidth="2.58287" strokeLinecap="round" />
    <path d="M7.16602 44.5H41.389" stroke="#121212" strokeWidth="2.58287" strokeLinecap="round" />
    <path d="M7.16602 10.114H41.389" stroke="#121212" strokeWidth="2.58287" strokeLinecap="round" />
    <path
      d="M45.7954 11.9556H37.2505C36.5241 11.9556 35.9351 11.3665 35.9351 10.6401V2.71924L45.7954 11.9556Z"
      fill="white"
      stroke="#454643"
      strokeWidth="1.36957"
    />
  </svg>
)
